<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="1" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container2 v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container2>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container2 from '@/components/Container2.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        video:{
          title:'國人十大癌症 肺癌',
          videosrc:'R03.mp4',
          list:[
            {

              title:'放射治療流程',
              body:"透過精準的儀器設備以及呼吸追蹤裝置，遵循醫師及相關工作人員的指示，提供您在治療過程能準確的將放射線打擊在腫瘤上，以期達到治癒的目的。整體治療流程的說明，讓病患能安心地且充滿信心地完成治療。"

            }

          ]
        },
        text:{
          title:'國人十大癌症 － 肺癌',
          videobtnname:'治療流程',
          videoImg:'R03v.png',
          list:[
            {

              title:'肺癌是什麼？',
              body:"它是一種生長於支氣管或肺泡的惡性腫瘤。根據國民健康署2016年癌症登記報告顯示，發生率位居第二位。"

            },
            {

              title:'如何治療肺癌？',
              body:"最好的方法就是能切除腫瘤，但是肺癌可切除率僅有25-40％之間，若轉移到淋巴腺或遠處的話，就不適合開刀此時化學治療及電療就可以輔助。"

            },
            {

              title:'肺癌放射治療的原因和時機？',
              body:[
                "早期肺癌，若病人體力較差，或年齡太大無法開刀。",
                "手術治療後，因術後發現縱膈腔的淋巴腺有癌細胞轉移，或是病理報告發現腫瘤侵犯到淋巴腺以外的軟組織，或是癌細胞距離手術時切除的邊界很近時，可以用放射治療來降低復發的風險，增加治癒的機會。",
                "晚期肺癌無法以手術治療的病人。",
                "若發生骨轉移、腦轉移、咳血或壓迫大血管等狀況用來減輕病人的不適和症狀。"
              ]

            },
          ]
        }
      },


    }
  },
  components: {
    Back,Container2,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
